import { LEGACY_KEYS } from "@hachi/core";
import type { GarageState } from "@hachi/core";
import { readJson, writeJson } from "./storage";
import type { KeyValue } from "./storage";

/**
 * Automatic copies kept in this browser: the first time the app opens each day and before big
 * changes (`addRestorePoint`). Same key and shape as the current app, so they survive the switch.
 */
export interface RestorePoint { id: string; at: string; reason: string; cars: number; entries: number; data: GarageState }

export const RESTORE_POINT_MAX = 20;

export function createRestorePoints(kv: KeyValue, newId: () => string, now: () => number = Date.now) {
  const list = (): RestorePoint[] => {
    const l = readJson<RestorePoint[]>(kv, LEGACY_KEYS.restorePoints);
    return Array.isArray(l) ? l : [];
  };
  /** When space runs out the oldest go first, then nothing is kept. */
  const store = (points: RestorePoint[]) => {
    const l = [...points];
    while (l.length) {
      if (writeJson(kv, LEGACY_KEYS.restorePoints, l)) return true;
      l.shift();
    }
    writeJson(kv, LEGACY_KEYS.restorePoints, null);
    return false;
  };
  return {
    list,
    add(st: GarageState, reason: string) {
      if (!st.cars.length && !st.log.length) return;
      const l = list();
      l.push({ id: newId(), at: new Date(now()).toISOString(), reason, cars: st.cars.length, entries: st.log.length, data: structuredClone(st) });
      store(l.slice(-RESTORE_POINT_MAX));
    },
    find: (id: string) => list().find((x) => x.id === id) ?? null,
  };
}

export type RestorePoints = ReturnType<typeof createRestorePoints>;
